import React from 'react';
import { Link } from "react-router-dom";

const Footer = () => {

    return (
        <>
            <footer className="MainFooter">
                <div className="container">
                    <div className="row gy-4">
                        <div className="col-lg-3 col-md-6">
                            <div className='footerlinks'>
                                <h4>Life Insurance</h4>
                                <ul>
                                    <li><a href={void(0)}>Term Life Insurance</a></li>
                                    <li><a href={void(0)}>Group Term Life</a></li>
                                    <li><a href={void(0)}>1 Crore Term Insurance</a></li>
                                </ul>
                            </div>
                            <div className='footerlinks'>
                                <h4>Motor Insurance</h4>
                                <ul>
                                    <li><Link to={"/prequotes/car-insurance-online"}>Car Insurance</Link></li>
                                    <li><a href={void(0)}>Two Wheeler Insurance</a></li>
                                    <li><a href={void(0)}>Goods Carrying Vehicle</a></li>
                                    <li><a href={void(0)}>Passenger Carrying Vehicle</a></li>
                                    <li><a href={void(0)}>Misc-D</a></li>
                                </ul>
                            </div>
                            <div className='footerlinks'>
                                <h4>Services</h4>
                                <ul>
                                    <li><a href={void(0)}>Claims</a></li>
                                    <li><a href={void(0)}>Inspection Status</a></li>
                                    <li><a href={void(0)}>E-Insurance</a></li>
                                    <li><a href={void(0)}>Grievance Redressal</a></li>
                                    <li><a href={void(0)}>Insurance Ombudsman</a></li>
                                    <li><a href={void(0)}>RTO Offices In India</a></li>
                                    <li><a href={void(0)}>Downloads</a></li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                            <div className='footerlinks'>
                                <h4>Health Insurance</h4>
                                <ul>
                                    <li><a href={void(0)}>Individual Health Insurance</a></li>
                                    <li><a href={void(0)}>Family Health Insurance</a></li>
                                    <li><a href={void(0)}>Multi-individual</a></li>
                                    <li><a href={void(0)}>Critical Illness Insurance</a></li>
                                    <li><a href={void(0)}>Arogya Sanjeevani Policy </a></li>
                                    <li><a href={void(0)}>Personal Accident Insurance</a></li>
                                    <li><a href={void(0)}>cancer insurance </a></li>
                                    <li><a href={void(0)}>1 crore health cover </a></li>
                                    <li><a href={void(0)}>group health insurance</a></li>
                                    <li><a href={void(0)}>group personal accident</a></li>
                                </ul>
                            </div>
                            <div className='footerlinks'>
                                <h4>Services</h4>
                                <ul>
                                    <li><a href={void(0)}>Claims</a></li>
                                    <li><a href={void(0)}>Inspection Status</a></li>
                                    <li><a href={void(0)}>E-Insurance</a></li>
                                    <li><a href={void(0)}>Grievance Redressal</a></li>
                                    <li><a href={void(0)}>Insurance Ombudsman</a></li>
                                    <li><a href={void(0)}>RTO Offices In India</a></li>
                                    <li><a href={void(0)}>Downloads</a></li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                            <div className='footerlinks'>
                                <h4>Other Insurance</h4>
                                <ul>
                                    <li><a href={void(0)}>individual travel insurance</a></li>
                                    <li><a href={void(0)}>family travel insurance</a></li>
                                    <li><a href={void(0)}>student travel insurance</a></li>
                                    <li><a href={void(0)}>endowment policy </a></li>
                                    <li><a href={void(0)}>guaranteed return plans</a></li>
                                    <li><a href={void(0)}>marine insurance </a></li>
                                    <li><a href={void(0)}>hull insurance</a></li>
                                    <li><a href={void(0)}>bharat griha</a></li>
                                    <li><a href={void(0)}>bharat laghu</a></li>
                                    <li><a href={void(0)}>bharat sookshma udyam</a></li>
                                    <li><a href={void(0)}>package policy</a></li>
                                    <li><a href={void(0)}>construction all risk </a></li>
                                    <li><a href={void(0)}>errection all risk</a></li>
                                    <li><a href={void(0)}>contractor’s plant & machinery </a></li>
                                    <li><a href={void(0)}>cattle insurance </a></li>
                                    <li><a href={void(0)}>crop insurance</a></li>
                                    <li><a href={void(0)}>film insurance </a></li>
                                    <li><a href={void(0)}>event insurance </a></li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                            <div className='footerlinks'>
                                <h4>Useful Links</h4>
                                <ul>
                                    <li><a href={"/about-us"}>About Us</a></li>
                                    <li><a href={void(0)}>Products</a></li>
                                    <li><a href={void(0)}>Grievance Redress Policy</a></li>
                                    <li><a href={void(0)}>Terms & Conditions</a></li>
                                    <li><a href={void(0)}>License</a></li>
                                    <li><a href={void(0)}>ISNP</a></li>
                                    <li><a href={void(0)}>Privacy Policy</a></li>
                                    <li><Link href={"/contact-us"}>Contact Us</Link></li>
                                </ul>
                            </div>
                            <div className="footercontact">
                                <h4>Contact Us</h4>
                                <p>C/O Baijnath Jaiswal</p>
                                <p>Mahadeva Buzurg, Anand nagar</p>
                                <p>Maharajganj UP 273155 IN</p>
                                <p className="mt-4"><strong>Phone:</strong> <span>+91 9519166608</span></p>
                                <p><strong>Email:</strong> <span>AMIT3188@GMAIL.COM</span></p>
                            </div>
                            <div className="sociallinks d-flex mt-4">
                                <a href={void(0)}><i className="fa-brands fa-x-twitter"></i></a>
                                <a href={void(0)}><i className="fa-brands fa-facebook"></i></a>
                                <a href={void(0)}><i className="fa-brands fa-instagram"></i></a>
                                <a href={void(0)}><i className="fa-brands fa-linkedin-in"></i></a>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='copyright'>
                    <div className="container text-center">
                        <p>AIBROM INSURANCE BROKING PRIVATE LIMITED | Reg. Office - C/O Baijnath Jaiswal Mahadeva Buzurg, Anand nagar, Maharajganj UP 273155 IN | IRDAI Direct Insurance Broker (Life & General) | License No.- 922 | Valid From - 07/12/2023 to Valid Till - 06/12/2026 Code No. - IRDAI/DB1040/2023 | CIN No - U67200UP2022PTC170642 | GST No - 09AAXCA6331L1Z0 | T&C Apply* Copyright © AIBROM INSURANCE BROKING PRIVATE LIMITED. All Rights Reserved</p>
                    </div>
                </div>
            </footer>

        </>
    );
};

export default Footer;
